import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from "../utils";
import { ENDPOINTS } from "../constants";
export var ActionTypes = {
  ACCOUNTS_FETCH: 'accounts/fetch',
  ACCOUNTS_UPDATE: 'accounts/update',
  INIT_DATA_FETCH: 'initData/fetch',
  SIDE_MENU_COMMON_DATA: 'commonData/fetch',
  NOT_AUTH_FETH: 'notAuth/fetch',
  NOTIFICATIONS_FETCH: 'notifications/fetch',
  ORANGE_COMBO_FETCH: 'orange/combo/fetch'
};
export var ActionCreator = {
  fetchAccounts: createAsyncThunk(ActionTypes.ACCOUNTS_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return apiClient.get(ENDPOINTS.accountsEndpoint);
        case 2:
          result = _context.sent;
          return _context.abrupt("return", result.data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))),
  updateAccountsList: createAction(ActionTypes.ACCOUNTS_UPDATE),
  fetchInitData: createAsyncThunk(ActionTypes.INIT_DATA_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return apiClient.get(ENDPOINTS.initData);
        case 2:
          result = _context2.sent;
          return _context2.abrupt("return", result.data);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))),
  fetchCommonData: createAsyncThunk(ActionTypes.SIDE_MENU_COMMON_DATA, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return apiClient.get(ENDPOINTS.fetchSideMenuData);
        case 2:
          result = _context3.sent;
          return _context3.abrupt("return", result.data);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }))),
  fetchNotAuthData: createAsyncThunk(ActionTypes.NOT_AUTH_FETH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return apiClient.get(ENDPOINTS.notAuthData);
        case 2:
          result = _context4.sent;
          return _context4.abrupt("return", result.data);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }))),
  fetchNotifications: createAsyncThunk(ActionTypes.NOTIFICATIONS_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return apiClient.get(ENDPOINTS.notifications);
        case 2:
          result = _context5.sent;
          return _context5.abrupt("return", result.data);
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }))),
  fetchOrangeComboInfo: createAsyncThunk(ActionTypes.ORANGE_COMBO_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return apiClient.get(ENDPOINTS.fetchOrangeComboInfo);
        case 2:
          result = _context6.sent;
          return _context6.abrupt("return", result.data);
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  })))
};